import type { FitsFileMeta } from "../fits/types"

const FIT_EXT_REGEX = /\.(fit|fits)$/i

export async function scanFits(
  dirHandle: FileSystemDirectoryHandle,
): Promise<FitsFileMeta[]> {
  const results: FitsFileMeta[] = []
  await walkDirectory(dirHandle, "", results)
  return results
}

async function walkDirectory(
  dirHandle: FileSystemDirectoryHandle,
  prefix: string,
  out: FitsFileMeta[],
): Promise<void> {
  // Use any-casts because the File System Access API is still stabilizing in TypeScript's DOM lib.
  const iterable = (dirHandle as any).entries() as AsyncIterable<
    [string, FileSystemHandle]
  >

  for await (const [name, handle] of iterable) {
    const relativePath = prefix ? `${prefix}/${name}` : name

    if (handle.kind === "file" && FIT_EXT_REGEX.test(name)) {
      out.push({
        name,
        relativePath,
        handle: handle as FileSystemFileHandle,
      })
    } else if (handle.kind === "directory") {
      await walkDirectory(handle as FileSystemDirectoryHandle, relativePath, out)
    }
  }
}


